import { useCallback } from 'react'
import { ProductionRouteAsset } from '@/features/production-routes/api/ProductionRouteModel'
import ProcessEmissionsReporting from './ProcessEmissionsReporting'
import { useUpdateMethodEmissionReport } from '@/hooks/api/emissionReports'
import { AssetDefinition } from '@/shared/hooks/api/appConfig'
import { AssetEmissionRecord } from '@/api/EmissionReportModel'
export type AssetWithMetadata = {
  assetDefinition: AssetDefinition | null
  productionRouteAsset: ProductionRouteAsset
  emissionRecords: AssetEmissionRecord[]
}

export type EmissionTypeToReport = {
  emissionType: string
  possibleMethods: string[]
  productionRouteAsset: ProductionRouteAsset
  assetDefinition: AssetDefinition | null
  emissionRecord: AssetEmissionRecord | null
}

export default function ProcessEmissionsSection({
  activityLevel,
  isViewMode,
  processId,
  reportId,
  emissionsRaw,
  areCombustionAssetsComplete,
  areCo2AssetsComplete,
  arePfcAssetsComplete,
  emissionsToReport
}: {
  areCombustionAssetsComplete: boolean
  areCo2AssetsComplete: boolean
  arePfcAssetsComplete: boolean
  activityLevel: number
  emissionsToReport: EmissionTypeToReport[]
  isViewMode: boolean
  reportId: string
  processId: string
  emissionsRaw: AssetEmissionRecord[]
}) {
  const { mutateAsync } = useUpdateMethodEmissionReport(reportId, processId)
  const onUpdateEmissionForAsset: (
    emissionId: string,
    state: AssetEmissionRecord
  ) => Promise<void> = async (emissionId, state) => {
    const updatedEmissionsRaw = emissionsRaw.map(er => {
      if (er.id === emissionId) {
        return state
      }

      return er
    })
    mutateAsync({
      emissionsRaw: updatedEmissionsRaw
    })
  }

  const onCreateEmissioForAsset: (state: AssetEmissionRecord) => Promise<void> = async state => {
    mutateAsync({
      emissionsRaw: [...emissionsRaw, state]
    })
  }

  const onRemoveEmissionForAsset = useCallback(
    async (emissionId: string) => {
      const updatedEmissionsRaw = emissionsRaw.filter(er => er.id !== emissionId)
      mutateAsync({
        emissionsRaw: updatedEmissionsRaw
      })
    },
    [emissionsRaw, mutateAsync]
  )

  return (
    <ProcessEmissionsReporting
      removeEmissionForAsset={onRemoveEmissionForAsset}
      updateEmissionForAsset={onUpdateEmissionForAsset}
      createEmissionForAsset={onCreateEmissioForAsset}
      emissionsToReport={emissionsToReport}
      activityLevel={activityLevel}
      isViewMode={isViewMode}
      areCombustionAssetsComplete={areCombustionAssetsComplete}
      areCo2AssetsComplete={areCo2AssetsComplete}
      arePfcAssetsComplete={arePfcAssetsComplete}
    />
  )
}
